import React, { FC } from 'react';
import { Typography, Button } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../common/styles/colors';
import { Routes } from '../../../common/enums/routes';
import Link from 'next/link';
import { RocketIcon } from '../../../common/components/Icon/Icons/Rocket.icon';
import { Add } from '@mui/icons-material';

export const MyIdeasCard: FC = () => {
  return (
    <Link
      href={Routes.MyProjects}
      style={{ textDecoration: 'none', width: '100%', height: '100%' }}
    >
      <CardWrapper>
        <IconWrapper>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '24px',
            }}
          >
            <RocketIcon />
          </div>
        </IconWrapper>

        <Title variant="h3">Moje nápady</Title>

        <Description variant="body1">
          Pro každý nápad náš k dispozici Průvodce podnikáním, který obsahuje
          články a videa nabité informacemi o podnikání. Získáš shrnutí tvého
          nápadu a doporučíme ti další kroky přímo tobě na míru.
        </Description>

        <CreateButton
          variant="contained"
          startIcon={<Add width={24} height={24} />}
        >
          Založit nápad
        </CreateButton>
      </CardWrapper>
    </Link>
  );
};

const CardWrapper = styled.div`
  padding: 0px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const IconWrapper = styled.div`
  svg {
    color: ${colors.brand};
  }
`;

const Title = styled(Typography)`
  color: ${colors.brand};
  font-weight: 600;
  font-size: 22.2px;
`;

const Description = styled(Typography)`
  color: ${colors.brand};
  line-height: 1.6;
  margin-bottom: 24px;
  max-width: 280px;
`;

const CreateButton = styled(Button)`
  background-color: ${colors.buttonLightBlue};
  color: ${colors.brand};
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 400;
  text-transform: none;

  &:hover {
    background-color: ${colors.blueActive};
    color: ${colors.white};
  }
`;
